import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { LandingPageBlock, GallerySummary } from '../../../models/cms-models';

@Component({
  selector: 'cms-landing-page-gallery-block-editor',
  imports: [CommonModule, FormsModule],
  templateUrl: './landing-page-gallery-block-editor.html',
  styleUrl: './landing-page-block-editor-fields.css',
})
export class LandingPageGalleryBlockEditorComponent {
  @Input({ required: true }) block!: LandingPageBlock;
  @Input() availableGalleries: GallerySummary[] = [];
  @Output() blockChange = new EventEmitter<Partial<LandingPageBlock>>();

  get selectedGallery(): GallerySummary | null {
    return this.availableGalleries.find((gallery) => gallery.id === this.block.galleryId) ?? null;
  }

  updateGalleryId(value: string): void {
    this.blockChange.emit({ galleryId: value || null });
  }
}
